const apiBase = (process.env.VUE_APP_APIENDPOINT || '').replace(/\/+$/, '')

export default {
  // Endpoints — Sanctum admin panel (`AdminLoginController`), not Ad Stream JWT `auth/login`.
  loginEndpoint: apiBase ? `${apiBase}/auth/admin/login` : 'https://api.mypoda.com/api/v1/auth/admin/login',
  registerEndpoint: '/jwt/register',
  refreshEndpoint: '/jwt/refresh-token',
  logoutEndpoint: '/jwt/logout',
  forgotPasswordEndpoint: apiBase ? `${apiBase}/auth/admin/reset-password-link` : '',
  verifyOtpEndpoint: apiBase ? `${apiBase}/auth/admin/verify-otp` : '',
  resetPasswordEndpoint: apiBase ? `${apiBase}/auth/admin/reset-password` : '',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
}
